<template>
    <!-- Untuk Tablet Keatas -->
  <div class="dashboard-highlight d-none d-sm-block">
    <div class="row">
      <div class="col-12">
        <div class="card" v-bind:style="dashboardAccebility(isAccebility)">
          <div class="card-body">
            <div class="row">
              <a v-bind:class="columnStyle.columnItems+' items'" :align="columnStyle.align" :style="styleCursor(data.jumlahDataset)" :href="pageUrl('dataset', data.jumlahDataset)" @mouseover="accebility(data.jumlahDataset+' Dataset')">
                <span><img v-bind:src="imageDataset" class="logo"></span>
                <span class="count">{{ data.jumlahDataset }}</span>
                <span class="title">Dataset</span>
              </a>
              <a v-bind:class="columnStyle.columnItems+' items'" :align="columnStyle.align" :style="styleCursor(data.jumlahSurvei)" :href="pageUrl('analisis', data.jumlahSurvei)" @mouseover="accebility(data.jumlahSurvei+' Surfai')">
                <span>
                  <img v-bind:src="imageSurvei"  class="logo">
                </span>
                <span class="count">{{ data.jumlahSurvei }}</span>
                <span class="title">Survei</span>
              </a>
              <a v-bind:class="columnStyle.columnItems+' items'" :align="columnStyle.align" :style="styleCursor(data.jumlahProdukStatistik)" :href="pageUrl('produk-statistik', data.jumlahProdukStatistik)" @mouseover="accebility(data.jumlahProdukStatistik+' Produk Statistik')">
                <span>
                  <img v-bind:src="imageProdukStatistik" class="logo">
                </span>
                <span class="count">{{ data.jumlahProdukStatistik }}</span>
                <span class="title">Produk Statistik</span>
              </a>
                <a v-if="data.jumlahDashboard > 10" v-bind:class="columnStyle.columnItems+' items'" :align="columnStyle.align" :style="styleCursor(data.jumlahDashboard)" :href="pageUrl('dashboard-analytic', data.jumlahDashboard)" @mouseover="accebility(data.jumlahDashboard+' Dashboard')">
                  <span>
                    <img v-bind:src="imageDashboard" class="logo">
                  </span>
                  <span class="count">{{ data.jumlahDashboard }}</span>
                  <span class="title">Dashboard</span>
                </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- Untuk Mobile -->
  <div class="dashboard-highlight d-block d-sm-none">
    <div class="row">
      <div class="col-12">
        <div class="card" v-bind:style="dashboardAccebility(isAccebility)">
          <div class="card-body">
            <div class="row">
              <a v-bind:class="columnStyle.columnItems+' items'" :align="columnStyle.align" :style="styleCursor(data.jumlahDataset)" :href="pageUrl('dataset', data.jumlahDataset)" @mouseover="accebility(data.jumlahDataset+' Dataset')">
                <div class="row">
                  <div class="col-sm-12"><img v-bind:src="imageDataset" class="logo"></div>
                  <div class="col-sm-12 count">{{ data.jumlahDataset }}</div>
                  <div class="col-sm-12 title">Dataset</div>
                </div>
              </a>
              <a v-bind:class="columnStyle.columnItems+' items'" :align="columnStyle.align" :style="styleCursor(data.jumlahSurvei)" :href="pageUrl('analisis', data.jumlahSurvei)" @mouseover="accebility(data.jumlahSurvei+' Surfai')">
                <div class="row">
                  <div class="col-sm-12"><img v-bind:src="imageSurvei" class="logo"></div>
                  <div class="col-sm-12 count">{{ data.jumlahSurvei }}</div>
                  <div class="col-sm-12 title">Survei</div>
                </div>
              </a>
              <a v-bind:class="columnStyle.columnItems+' items'" :align="columnStyle.align" :style="styleCursor(data.jumlahProdukStatistik)" :href="pageUrl('produk-statistik', data.jumlahProdukStatistik)" @mouseover="accebility(data.jumlahProdukStatistik+' Produk Statistik')">
                <div class="row">
                  <div class="col-sm-12"><img v-bind:src="imageProdukStatistik" class="logo"></div>
                  <div class="col-sm-12 count">{{ data.jumlahProdukStatistik }}</div>
                  <div class="col-sm-12 title">Produk Statistik</div>
                </div>
              </a>
                <a v-if="data.jumlahDashboard > 10" v-bind:class="columnStyle.columnItems+' items'" :align="columnStyle.align" :style="styleCursor(data.jumlahDashboard)" :href="pageUrl('dashboard-analytic', data.jumlahDashboard)" @mouseover="accebility(data.jumlahDashboard+' Dashboard')">
                  <div class="row">
                    <div class="col-sm-12"><img v-bind:src="imageDashboard" class="logo"></div>
                    <div class="col-sm-12 count">{{ data.jumlahDashboard }}</div>
                    <div class="col-sm-12 title">Dashboard</div>
                  </div>
                </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

</template>
<script>
  import axios from 'axios';
  export default {
    name: 'DashbordhighlightComponents',
    components: {},
    data() {
      return {
        baseUrl:this.$store.state.baseUrl,
        baseApi:this.$store.state.apiUrl,
        data: [],        
        isAccebility:this.$store.state.isAccebility,
        imageDataset:require('@/assets/icon/icon-dataset.png'),
        imageDashboard:require('@/assets/icon/icon-analisa.png'),
        imageSurvei:require('@/assets/icon/icon-survei.png'),
        imageProdukStatistik:require('@/assets/icon/icon-produk-statistik.png'),
        columnStyle: [],
        windowWidth: window.innerWidth
      }
    },
    mounted() {
     
      axios.get(`${this.baseApi}/api/v2/satudata/dashboard-highlights`).then(res => {
          this.data = res.data;
          this.jumlahDashboard = res.data.jumlahDashboard;

          if(this.jumlahDashboard > 10){
              if (this.windowWidth <= 410) {
                  this.columnStyle = {
                      columnItems: "col-3",
                      align: 'center'
                  };
              } else if(this.windowWidth > 410 && this.windowWidth <= 820) {
                  this.columnStyle = {
                      columnItems: "col-3",
                      align: 'center'
                  };
              } else if(this.windowWidth > 820 && this.windowWidth <= 1230) {
                  this.columnStyle = {
                      columnItems: "col-3",
                      align: 'center'
                  }; 
              } else {
                  this.columnStyle = {
                      columnItems: "col-3",
                      align: 'center'
                  }; 
              }
          } else {
              if (this.windowWidth <= 410) {
                  this.columnStyle = {
                      columnItems: "col-4",
                      align: 'center'
                  };
              } else if(this.windowWidth > 410 && this.windowWidth <= 820) {
                  this.columnStyle = {
                      columnItems: "col-4",
                      align: 'center'
                  };
              } else {
                  this.columnStyle = {
                      columnItems: "col-4",
                      align: 'center'
                  }; 
              }
          }
      });


    },
    methods: {
      styleCursor(item) {
        if(this.isAccebility.modeMalam){
          this.imageDataset = require('@/assets/icon/icon-dataset-dark.png')
          this.imageDashboard = require('@/assets/icon/icon-analisa-dark.png')
          this.imageSurvei = require('@/assets/icon/icon-survei-dark.png'),
          this.imageProdukStatistik = require('@/assets/icon/icon-produk-statistik-dark.png')
          if (item > 0) {
            return {
              cursor: 'pointer',
              color: 'white'
            }
          } else {
            return {
              color: 'white'
            }
          }
        } else {
          if (item > 0) {
            return {
              cursor: 'pointer',
              color: '#052158'
            }
          } else {
            return {
              color: '#052158'
            }
          }
        }
        
      },
      dashboardAccebility(isAccebility){
        if(isAccebility.modeMalam){
          this.imageDataset = require('@/assets/icon/icon-dataset-dark.png')
          this.imageDashboard = require('@/assets/icon/icon-analisa-dark.png')
          this.imageSurvei = require('@/assets/icon/icon-survei-dark.png'),
          this.imageProdukStatistik = require('@/assets/icon/icon-produk-statistik-dark.png')
          return{
            backgroundColor: 'black'
          }
        } else {
          this.imageDataset = require('@/assets/icon/icon-dataset.png')
          this.imageDashboard = require('@/assets/icon/icon-analisa.png')
          this.imageSurvei = require('@/assets/icon/icon-survei.png'),
          this.imageProdukStatistik = require('@/assets/icon/icon-produk-statistik.png')
          return{
            backgroundColor: 'white'
          }
        }
      },
      toPage(item, jumlah) {
        if (jumlah > 0 && item == 'dataset') {
          window.location.href = "search?q=&halaman=open-data&kategori=dataset&topik=all&organisasi=all&status=all&sort=desc&page_no=1&show_filter=true&lang=id"
        } else if (jumlah > 0 && item == 'produk-statistik') {
          window.location.href = "search?q=&halaman=statistik-sektoral&kategori=produk-statistik&topik=all&organisasi=all&status=all&sort=desc&page_no=1&show_filter=true&lang=id"        
        } else if (jumlah > 0 && item == 'analisis') {
          window.location.href = "search?q=&halaman=statistik-sektoral&kategori=analisis&topik=all&organisasi=all&status=all&sort=desc&page_no=1&show_filter=true&lang=id"
        } else if (jumlah > 0 && item == 'dashboard-analytic') {
          window.location.href = "search?q=&halaman=dashboard-analytic&kategori=dashboard-analytic&topik=all&organisasi=all&status=all&sort=desc&page_no=1&show_filter=true&lang=id"
        }
      },
      pageUrl(item, jumlah) {
        if (jumlah > 0 && item == 'dataset') {
          return this.baseUrl + "/search?q=&halaman=open-data&kategori=dataset&topik=all&organisasi=all&status=all&sort=desc&page_no=1&show_filter=true&lang=id"
        } else if (jumlah > 0 && item == 'produk-statistik') {
          return this.baseUrl + "/search?q=&halaman=statistik-sektoral&kategori=produk-statistik&topik=all&organisasi=all&status=all&sort=desc&page_no=1&show_filter=true&lang=id"        
        } else if (jumlah > 0 && item == 'analisis') {
          return this.baseUrl + "/search?q=&halaman=statistik-sektoral&kategori=analisis&topik=all&organisasi=all&status=all&sort=desc&page_no=1&show_filter=true&lang=id"
        } else if (jumlah > 0 && item == 'dashboard-analytic') {
          return this.baseUrl + "/search?q=&halaman=open-data&kategori=dashboard-analytic&topik=all&organisasi=all&status=all&sort=desc&page_no=1&show_filter=true&lang=id"
        }
      },
      accebility(voice){
        if(this.isAccebility.modeSuara){
          let msg = new SpeechSynthesisUtterance();
          let voices = window.speechSynthesis.getVoices()
          msg.voice = voices[160];
          msg.text = voice;
          msg.volume = 10;
          msg.rate = 1;
          msg.pitch = 1;
          window.speechSynthesis.cancel();
          window.speechSynthesis.speak(msg);
        }
      },
      eventChngescreen(e) {
        this.windowWidth = e.currentTarget.screen.availWidth
     
        if(this.jumlahDashboard > 10){
          if (this.windowWidth <= "410") {
            this.columnStyle = {
              columnItems: "col-3",
              align:'center'
            };
          } else if(this.windowWidth > "410" && this.windowWidth <= "820") {
            this.columnStyle = {
              columnItems: "col-3",
              align:'center'
            };
          } else if(this.windowWidth > "820" && this.windowWidth <= "1230") {
            this.columnStyle = {
              columnItems: "col-3",
              align:'center'
            }; 
          }else {
            this.columnStyle = {
              columnItems: "col-3",
              align:'center'
            }; 
          }
        }else {
          if (this.windowWidth <= "410") {
            this.columnStyle = {
              columnItems: "col-4",
              align:'center'
            };
          } else if(this.windowWidth > "410" && this.windowWidth <= "820") {
            this.columnStyle = {
              columnItems: "col-4",
              align:'center'
            };
          } else {
            this.columnStyle = {
              columnItems: "col-4",
              align:'center'
            }; 
          }
        }

      }
    },
    created() {
      window.addEventListener("resize", this.eventChngescreen);
    },
    beforeUnmount() {
      window.removeEventListener("resize", this.eventChngescreen);
    },
  }
</script>